import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBars,
  faPowerOff,
  faBell,
  faExclamationCircle,
} from '@fortawesome/free-solid-svg-icons';

library.add(faBars, faPowerOff, faBell, faExclamationCircle);

export default library;
